export const Country = {
	AFG: { key: 'AFG', name: 'Afghanistan' },
	ALB: { key: 'ALB', name: 'Albania' },
	DZA: { key: 'DZA', name: 'Algeria' },
	ASM: { key: 'ASM', name: 'American Samoa' },
	AND: { key: 'AND', name: 'Andorra' },
	AGO: { key: 'AGO', name: 'Angola' },
	AIA: { key: 'AIA', name: 'Anguilla' },
	ATA: { key: 'ATA', name: 'Antarctica' },
	ATG: { key: 'ATG', name: 'Antigua and Barbuda' },
	ARG: { key: 'ARG', name: 'Argentina' },
	ARM: { key: 'ARM', name: 'Armenia' },
	ABW: { key: 'ABW', name: 'Aruba' },
	AUS: { key: 'AUS', name: 'Australia' },
	AUT: { key: 'AUT', name: 'Austria' },
	AZE: { key: 'AZE', name: 'Azerbaijan' },
	BHS: { key: 'BHS', name: 'Bahamas' },
	BHR: { key: 'BHR', name: 'Bahrain' },
	BGD: { key: 'BGD', name: 'Bangladesh' },
	BRB: { key: 'BRB', name: 'Barbados' },
	BLR: { key: 'BLR', name: 'Belarus' },
	BEL: { key: 'BEL', name: 'Belgium' },
	BLZ: { key: 'BLZ', name: 'Belize' },
	BEN: { key: 'BEN', name: 'Benin' },
	BMU: { key: 'BMU', name: 'Bermuda' },
	BTN: { key: 'BTN', name: 'Bhutan' },
	BOL: { key: 'BOL', name: 'Bolivia, Plurinational State of' },
	BES: { key: 'BES', name: 'Bonaire, Saint Eustatius and Saba' },
	BIH: { key: 'BIH', name: 'Bosnia and Herzegovina' },
	BWA: { key: 'BWA', name: 'Botswana' },
	BVT: { key: 'BVT', name: 'Bouvet Island' },
	BRA: { key: 'BRA', name: 'Brazil' },
	IOT: { key: 'IOT', name: 'British Indian Ocean Territory' },
	BRN: { key: 'BRN', name: 'Brunei Darussalam' },
	BGR: { key: 'BGR', name: 'Bulgaria' },
	BFA: { key: 'BFA', name: 'Burkina Faso' },
	BDI: { key: 'BDI', name: 'Burundi' },
	KHM: { key: 'KHM', name: 'Cambodia' },
	CMR: { key: 'CMR', name: 'Cameroon' },
	CAN: { key: 'CAN', name: 'Canada' },
	CPV: { key: 'CPV', name: 'Cape Verde' },
	CYM: { key: 'CYM', name: 'Cayman Islands' },
	CAF: { key: 'CAF', name: 'Central African Republic' },
	TCD: { key: 'TCD', name: 'Chad' },
	CHL: { key: 'CHL', name: 'Chile' },
	CHN: { key: 'CHN', name: 'China' },
	CXR: { key: 'CXR', name: 'Christmas Island' },
	CCK: { key: 'CCK', name: 'Cocos (Keeling) Islands' },
	COL: { key: 'COL', name: 'Colombia' },
	COM: { key: 'COM', name: 'Comoros' },
	COG: { key: 'COG', name: 'Congo' },
	COD: { key: 'COD', name: 'Congo, the Democratic Republic of the' },
	COK: { key: 'COK', name: 'Cook Islands' },
	CRI: { key: 'CRI', name: 'Costa Rica' },
	HRV: { key: 'HRV', name: 'Croatia' },
	CUB: { key: 'CUB', name: 'Cuba' },
	CUW: { key: 'CUW', name: 'Curacao' },
	CYP: { key: 'CYP', name: 'Cyprus' },
	CZE: { key: 'CZE', name: 'Czechia' },
	CIV: { key: 'CIV', name: 'Cote d Ivoire' },
	DNK: { key: 'DNK', name: 'Denmark' },
	DJI: { key: 'DJI', name: 'Djibouti' },
	DMA: { key: 'DMA', name: 'Dominica' },
	DOM: { key: 'DOM', name: 'Dominican Republic' },
	ECU: { key: 'ECU', name: 'Ecuador' },
	EGY: { key: 'EGY', name: 'Egypt' },
	SLV: { key: 'SLV', name: 'El Salvador' },
	GNQ: { key: 'GNQ', name: 'Equatorial Guinea' },
	ERI: { key: 'ERI', name: 'Eritrea' },
	EST: { key: 'EST', name: 'Estonia' },
	ETH: { key: 'ETH', name: 'Ethiopia' },
	FLK: { key: 'FLK', name: 'Falkland Islands (Malvinas)' },
	FRO: { key: 'FRO', name: 'Faroe Islands' },
	FJI: { key: 'FJI', name: 'Fiji' },
	FIN: { key: 'FIN', name: 'Finland' },
	FRA: { key: 'FRA', name: 'France' },
	GUF: { key: 'GUF', name: 'French Guiana' },
	PYF: { key: 'PYF', name: 'French Polynesia' },
	ATF: { key: 'ATF', name: 'French Southern Territories' },
	GAB: { key: 'GAB', name: 'Gabon' },
	GMB: { key: 'GMB', name: 'Gambia' },
	GEO: { key: 'GEO', name: 'Georgia' },
	DEU: { key: 'DEU', name: 'Germany' },
	GHA: { key: 'GHA', name: 'Ghana' },
	GIB: { key: 'GIB', name: 'Gibraltar' },
	GRC: { key: 'GRC', name: 'Greece' },
	GRL: { key: 'GRL', name: 'Greenland' },
	GRD: { key: 'GRD', name: 'Grenada' },
	GLP: { key: 'GLP', name: 'Guadeloupe' },
	GUM: { key: 'GUM', name: 'Guam' },
	GTM: { key: 'GTM', name: 'Guatemala' },
	GGY: { key: 'GGY', name: 'Guernsey' },
	GIN: { key: 'GIN', name: 'Guinea' },
	GNB: { key: 'GNB', name: 'Guinea-Bissau' },
	GUY: { key: 'GUY', name: 'Guyana' },
	HTI: { key: 'HTI', name: 'Haiti' },
	HMD: { key: 'HMD', name: 'Heard Island and McDonald Islands' },
	VAT: { key: 'VAT', name: 'Holy See (Vatican City State)' },
	HND: { key: 'HND', name: 'Honduras' },
	HKG: { key: 'HKG', name: 'Hong Kong' },
	HUN: { key: 'HUN', name: 'Hungary' },
	ISL: { key: 'ISL', name: 'Iceland' },
	IND: { key: 'IND', name: 'India' },
	IDN: { key: 'IDN', name: 'Indonesia' },
	IRN: { key: 'IRN', name: 'Iran, Islamic Republic of' },
	IRQ: { key: 'IRQ', name: 'Iraq' },
	IRL: { key: 'IRL', name: 'Ireland' },
	IMN: { key: 'IMN', name: 'Isle of Man' },
	ISR: { key: 'ISR', name: 'Israel' },
	ITA: { key: 'ITA', name: 'Italy' },
	JAM: { key: 'JAM', name: 'Jamaica' },
	JPN: { key: 'JPN', name: '日本' },
	JEY: { key: 'JEY', name: 'Jersey' },
	JOR: { key: 'JOR', name: 'Jordan' },
	KAZ: { key: 'KAZ', name: 'Kazakhstan' },
	KEN: { key: 'KEN', name: 'Kenya' },
	KIR: { key: 'KIR', name: 'Kiribati' },
	PRK: { key: 'PRK', name: 'Korea, Democratic People s Republic of' },
	KOR: { key: 'KOR', name: 'Korea, Republic of' },
	KWT: { key: 'KWT', name: 'Kuwait' },
	KGZ: { key: 'KGZ', name: 'Kyrgyzstan' },
	LAO: { key: 'LAO', name: 'Lao People s Democratic Republic' },
	LVA: { key: 'LVA', name: 'Latvia' },
	LBN: { key: 'LBN', name: 'Lebanon' },
	LSO: { key: 'LSO', name: 'Lesotho' },
	LBR: { key: 'LBR', name: 'Liberia' },
	LBY: { key: 'LBY', name: 'Libya' },
	LIE: { key: 'LIE', name: 'Liechtenstein' },
	LTU: { key: 'LTU', name: 'Lithuania' },
	LUX: { key: 'LUX', name: 'Luxembourg' },
	MAC: { key: 'MAC', name: 'Macau' },
	MKD: { key: 'MKD', name: 'Macedonia, the former Yugoslav Republic of' },
	MDG: { key: 'MDG', name: 'Madagascar' },
	MWI: { key: 'MWI', name: 'Malawi' },
	MYS: { key: 'MYS', name: 'Malaysia' },
	MDV: { key: 'MDV', name: 'Maldives' },
	MLI: { key: 'MLI', name: 'Mali' },
	MLT: { key: 'MLT', name: 'Malta' },
	MHL: { key: 'MHL', name: 'Marshall Islands' },
	MTQ: { key: 'MTQ', name: 'Martinique' },
	MRT: { key: 'MRT', name: 'Mauritania' },
	MUS: { key: 'MUS', name: 'Mauritius' },
	MYT: { key: 'MYT', name: 'Mayotte' },
	MEX: { key: 'MEX', name: 'Mexico' },
	FSM: { key: 'FSM', name: 'Micronesia, Federated States of' },
	MDA: { key: 'MDA', name: 'Moldova, Republic of' },
	MCO: { key: 'MCO', name: 'Monaco' },
	MNG: { key: 'MNG', name: 'Mongolia' },
	MNE: { key: 'MNE', name: 'Montenegro' },
	MSR: { key: 'MSR', name: 'Montserrat' },
	MAR: { key: 'MAR', name: 'Morocco' },
	MOZ: { key: 'MOZ', name: 'Mozambique' },
	MMR: { key: 'MMR', name: 'Myanmar' },
	NAM: { key: 'NAM', name: 'Namibia' },
	NRU: { key: 'NRU', name: 'Nauru' },
	NPL: { key: 'NPL', name: 'Nepal' },
	NLD: { key: 'NLD', name: 'Netherlands' },
	NCL: { key: 'NCL', name: 'New Caledonia' },
	NZL: { key: 'NZL', name: 'New Zealand' },
	NIC: { key: 'NIC', name: 'Nicaragua' },
	NER: { key: 'NER', name: 'Niger' },
	NGA: { key: 'NGA', name: 'Nigeria' },
	NIU: { key: 'NIU', name: 'Niue' },
	NFK: { key: 'NFK', name: 'Norfolk Island' },
	MNP: { key: 'MNP', name: 'Northern Mariana Islands' },
	NOR: { key: 'NOR', name: 'Norway' },
	OMN: { key: 'OMN', name: 'Oman' },
	PAK: { key: 'PAK', name: 'Pakistan' },
	PLW: { key: 'PLW', name: 'Palau' },
	PSE: { key: 'PSE', name: 'Palestinian Territory, Occupied' },
	PAN: { key: 'PAN', name: 'Panama' },
	PNG: { key: 'PNG', name: 'Papua New Guinea' },
	PRY: { key: 'PRY', name: 'Paraguay' },
	PER: { key: 'PER', name: 'Peru' },
	PHL: { key: 'PHL', name: 'Philippines' },
	PCN: { key: 'PCN', name: 'Pitcairn' },
	POL: { key: 'POL', name: 'Poland' },
	PRT: { key: 'PRT', name: 'Portugal' },
	PRI: { key: 'PRI', name: 'Puerto Rico' },
	QAT: { key: 'QAT', name: 'Qatar' },
	ROU: { key: 'ROU', name: 'Romania' },
	RUS: { key: 'RUS', name: 'Russian Federation' },
	RWA: { key: 'RWA', name: 'Rwanda' },
	REU: { key: 'REU', name: 'Reunion' },
	BLM: { key: 'BLM', name: 'Saint Barthelemy' },
	SHN: { key: 'SHN', name: 'Saint Helena, Ascension and Tristan da Cunha' },
	KNA: { key: 'KNA', name: 'Saint Kitts and Nevis' },
	LCA: { key: 'LCA', name: 'Saint Lucia' },
	MAF: { key: 'MAF', name: 'Saint Martin (French part)' },
	SPM: { key: 'SPM', name: 'Saint Pierre and Miquelon' },
	VCT: { key: 'VCT', name: 'Saint Vincent and the Grenadines' },
	WSM: { key: 'WSM', name: 'Samoa' },
	SMR: { key: 'SMR', name: 'San Marino' },
	STP: { key: 'STP', name: 'Sao Tome and Principe' },
	SAU: { key: 'SAU', name: 'Saudi Arabia' },
	SEN: { key: 'SEN', name: 'Senegal' },
	SRB: { key: 'SRB', name: 'Serbia' },
	SYC: { key: 'SYC', name: 'Seychelles' },
	SLE: { key: 'SLE', name: 'Sierra Leone' },
	SGP: { key: 'SGP', name: 'Singapore' },
	SXM: { key: 'SXM', name: 'Sint Maarten (Dutch part)' },
	SVK: { key: 'SVK', name: 'Slovakia' },
	SVN: { key: 'SVN', name: 'Slovenia' },
	SLB: { key: 'SLB', name: 'Solomon Islands' },
	SOM: { key: 'SOM', name: 'Somalia' },
	ZAF: { key: 'ZAF', name: 'South Africa' },
	SGS: { key: 'SGS', name: 'South Georgia and the South Sandwich Islands' },
	SSD: { key: 'SSD', name: 'South Sudan' },
	ESP: { key: 'ESP', name: 'Spain' },
	LKA: { key: 'LKA', name: 'Sri Lanka' },
	SDN: { key: 'SDN', name: 'Sudan' },
	SUR: { key: 'SUR', name: 'Suriname' },
	SJM: { key: 'SJM', name: 'Svalbard and Jan Mayen' },
	SWZ: { key: 'SWZ', name: 'Swaziland' },
	SWE: { key: 'SWE', name: 'Sweden' },
	CHE: { key: 'CHE', name: 'Switzerland' },
	SYR: { key: 'SYR', name: 'Syrian Arab Republic' },
	TWN: { key: 'TWN', name: 'Taiwan, Province of China' },
	TJK: { key: 'TJK', name: 'Tajikistan' },
	TZA: { key: 'TZA', name: 'Tanzania, United Republic of' },
	THA: { key: 'THA', name: 'Thailand' },
	TLS: { key: 'TLS', name: 'Timor-Leste' },
	TGO: { key: 'TGO', name: 'Togo' },
	TKL: { key: 'TKL', name: 'Tokelau' },
	TON: { key: 'TON', name: 'Tonga' },
	TTO: { key: 'TTO', name: 'Trinidad and Tobago' },
	TUN: { key: 'TUN', name: 'Tunisia' },
	TUR: { key: 'TUR', name: 'Turkey' },
	TKM: { key: 'TKM', name: 'Turkmenistan' },
	TCA: { key: 'TCA', name: 'Turks and Caicos Islands' },
	TUV: { key: 'TUV', name: 'Tuvalu' },
	UGA: { key: 'UGA', name: 'Uganda' },
	UKR: { key: 'UKR', name: 'Ukraine' },
	ARE: { key: 'ARE', name: 'United Arab Emirates' },
	GBR: { key: 'GBR', name: 'United Kingdom' },
	USA: { key: 'USA', name: 'United States' },
	UMI: { key: 'UMI', name: 'United States Minor Outlying Islands' },
	URY: { key: 'URY', name: 'Uruguay' },
	UZB: { key: 'UZB', name: 'Uzbekistan' },
	VUT: { key: 'VUT', name: 'Vanuatu' },
	VEN: { key: 'VEN', name: 'Venezuela, Bolivarian Republic of' },
	VNM: { key: 'VNM', name: 'Viet Nam' },
	VGB: { key: 'VGB', name: 'Virgin Islands, British' },
	VIR: { key: 'VIR', name: 'Virgin Islands, U.S.' },
	WLF: { key: 'WLF', name: 'Wallis and Futuna' },
	ESH: { key: 'ESH', name: 'Western Sahara' },
	YEM: { key: 'YEM', name: 'Yemen' },
	ZMB: { key: 'ZMB', name: 'Zambia' },
	ZWE: { key: 'ZWE', name: 'Zimbabwe' },
	ALA: { key: 'ALA', name: 'Aland Islands' },
} as const;
export type CountryType = typeof Country[keyof typeof Country];

export const findCountryTypeNameByKey = (key: string) => {
	const country = Object.values(Country).find((p) => p.key === key);
	return country ? country.name : '';
};
